import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import SEO from "../../components/SEO";

// Asset Imports (Matches Home page assets)

import barcodeLable from "../../assets/barcode_labels.png";
import pharmaLable from "../../assets/pharma_labels.png";
import foodLable from "../../assets/food_labels.png";
import cosmeticLable from "../../assets/cosmetic_labels.png";

const works = [
  {
    title: "Premium FMCG & Retail Labels",
    subtitle: "High-Impact Commercial Branding",
    desc: "Vibrant, multi-color labels engineered for maximum shelf-appeal in the competitive consumer space. We use advanced color-matching systems to ensure brand consistency across millions of units.",
    points: [
      "8-Color UV Flexo Printing",
      "Specialty Spot Varnishes & Foiling",
      "Moisture & Oil Resistant Constructions",
      "High-Speed Automatic Application Ready",
    ],
    img: foodLable,
    isReversed: false,
  },
  {
    title: "Pharmaceutical & Healthcare",
    subtitle: "GMP-Compliant Information Systems",
    desc: "Critical labeling solutions for the life sciences sector where legibility and adhesion are non-negotiable. Our pharma-grade labels are produced in controlled environments.",
    points: [
      "Tamper-Evident Security Seals",
      "Low-Migration Inks for Safety",
      "Vial & Ampoule Diameter Specific",
      "Cryogenic & Autoclave Resistant",
    ],
    img: pharmaLable,
    isReversed: true,
  },
  {
    title: "Industrial & Logistics Tracking",
    subtitle: "Endurable Data Performance",
    desc: "Heavy-duty barcode and QR systems designed to survive extreme friction, heat, and chemical exposure in supply chain environments.",
    points: [
      "High-Scan-Rate Barcode Contrast",
      "Extreme Temperature Adhesives",
      "Variable Data Printing (VDP)",
      "Weather & UV Stable Materials",
    ],
    img: barcodeLable,
    isReversed: false,
  },
  {
    title: "Luxury Cosmetic Branding",
    subtitle: "Tactile Elegance & Finish",
    desc: "Premium constructions using metallic foils, soft-touch laminations, and 'Clear-on-Clear' substrates to create an invisible label look for high-end beauty products.",
    points: [
      "Cold Foil & Textured Embossing",
      "Matte & Gloss Dual-Finishing",
      "No-Label Look (Clear Film)",
      "Chemical & Solvent Resistant Clear Coats",
    ],
    img: cosmeticLable,
    isReversed: true,
  },
];

const OurWorks = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Our Works | Premium Label Portfolio Sahajink"
        description="View our portfolio of custom labels for Pharma, Cosmetics, Food, and Logistics industries. 1B+ labels printed for 500+ milestone projects globally."
        keywords="label printing portfolio, pharma label samples, cosmetic label gallery, custom stickers surat, industrial printing showcase"
      />
      <main className="min-h-screen overflow-x-hidden bg-[#0a1628] text-white">
        {/* Hero Section */}
        <section className="relative overflow-hidden pt-[160px] pb-10 md:pt-[180px] md:pb-24 lg:pt-[200px] lg:pb-40">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,rgba(37,99,235,0.18),transparent_40%),radial-gradient(circle_at_bottom_left,rgba(96,165,250,0.1),transparent_30%)]" />

          <div class="absolute inset-0 bg-[linear-gradient(rgba(255,255,255,0.03)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.03)_1px,transparent_1px)] bg-[size:48px_48px] opacity-60"></div>

          <div className="relative z-10 mx-auto max-w-[1200px] px-6 text-center">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="mb-8 inline-flex items-center gap-3 rounded-full border border-blue-400/20 bg-blue-500/10 px-6 py-2.5 text-[9px] sm:text-xs font-bold uppercase tracking-[0.3em] text-blue-300 backdrop-blur-md">
                <span className="h-2 w-2 animate-pulse rounded-full bg-blue-400 shadow-[0_0_12px_#60a5fa] animate-glow" />
                Our Works
              </div>

              <h1 className="mb-8 text-[34px] sm:text-[44px] font-black leading-[1.1] text-white md:text-[68px] lg:text-[72px] tracking-tight">
                Labels Engineered <br />
                <span className="bg-gradient-to-r from-blue-300 via-blue-400 to-cyan-300 bg-clip-text text-transparent">
                  For Real-World Performance.
                </span>
              </h1>

              <p className="mx-auto mb-12 max-w-[780px] text-[14px] sm:text-lg leading-relaxed text-blue-100/60 md:text-xl md:leading-9">
                Explore our portfolio of custom self-adhesive labels designed for Food, Pharmaceutical, Cosmetic, and Logistics applications. Built to meet exact manufacturing tolerances and brand presentation needs.
              </p>

              {/* <div className="grid gap-8 sm:grid-cols-3 max-w-[900px] mx-auto pt-8 border-t border-white/10">
              {[
                {
                  label: "Brands Served",
                  value: "500+",
                  sub: "Across Multiple Sectors",
                },
                {
                  label: "Labels Printed",
                  value: "500M+",
                  sub: "Total Roll Labels Delivered",
                },
                {
                  label: "Quality Benchmark",
                  value: "99.9%",
                  sub: "Strict QC Pass Rate",
                },
              ].map((stat, idx) => (
                <motion.div
                  key={stat.label}
                  initial={{ opacity: 0, y: 15 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.4 + idx * 0.1 }}
                >
                  <div className="text-3xl font-black text-white md:text-4xl">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-xs font-bold uppercase tracking-widest text-blue-400">
                    {stat.label}
                  </div>
                  <div className="text-[11px] text-white/40">{stat.sub}</div>
                </motion.div>
              ))}
            </div> */}
            </motion.div>
          </div>
        </section>

        {/* Zig-Zag Work Showcase */}
        <section className="bg-slate-50 py-20 sm:py-24 md:py-32">
          <div className="mx-auto max-w-[1200px] px-6">
            <div className="space-y-20 md:space-y-32">
              {works.map((work, idx) => (
                <motion.div
                  key={work.title}
                  initial={{ opacity: 0, y: 40 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8 }}
                  viewport={{ once: true, margin: "-100px" }}
                  className={`flex flex-col gap-12 lg:items-center ${work.isReversed ? "lg:flex-row-reverse" : "lg:flex-row"}`}
                >
                  {/* Image Side */}
                  <div className="relative w-full lg:w-1/2 group">
                    <div className="overflow-hidden rounded-[40px] shadow-2xl transition-all duration-700 group-hover:shadow-blue-500/20">
                      <img
                        src={work.img}
                        alt={work.title}
                        className="h-[350px] w-full object-cover transition-transform duration-1000 group-hover:scale-110 md:h-[500px]"
                      />
                      <div className="absolute inset-0 rounded-[40px] bg-gradient-to-tr from-blue-900/40 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                    </div>
                  </div>

                  {/* Content Side (White Background) */}
                  <div className="w-full lg:w-1/2">
                    <div className="rounded-[40px] bg-white p-8 shadow-[0_20px_60px_rgba(15,23,42,0.08)] transition-all duration-500 hover:shadow-[0_40px_100px_rgba(15,23,42,0.12)] md:p-14 lg:-mx-10 relative z-10">
                      <div className="mb-4 inline-block text-sm font-bold tracking-[0.2em] text-blue-600 uppercase">
                        {work.subtitle}
                      </div>
                      <h3 className="mb-6 text-3xl font-black text-slate-900 md:text-4xl lg:text-5xl tracking-tight">
                        {work.title}
                      </h3>
                      <p className="mb-10 text-lg font-medium leading-relaxed text-slate-600">
                        {work.desc}
                      </p>

                      <div className="grid gap-4 sm:grid-cols-2">
                        {work.points.map((point) => (
                          <div key={point} className="flex items-start gap-3">
                            <div className="mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-blue-50 text-blue-600">
                              <svg
                                viewBox="0 0 24 24"
                                className="h-3.5 w-3.5 fill-none"
                                stroke="currentColor"
                                strokeWidth="2.5"
                              >
                                <path
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  d="M5 13l4 4L19 7"
                                />
                              </svg>
                            </div>
                            <span className="text-sm font-bold text-slate-700">
                              {point}
                            </span>
                          </div>
                        ))}
                      </div>

                      <div className="mt-12 flex items-center gap-6">
                        <Link
                          to="/#contact"
                          className="text-sm font-black uppercase tracking-widest text-blue-600 hover:text-blue-700 flex items-center gap-2 group/btn"
                        >
                          Explore Spec Sheet
                          <svg
                            viewBox="0 0 24 24"
                            className="h-4 w-4 transition-transform group-hover/btn:translate-x-1"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2.5"
                          >
                            <path d="M13.5 4.5L21 12m0 0l-7.5 7.5M21 12H3" />
                          </svg>
                        </Link>
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Unique Industries Section - Impact Grid */}
        {/* Unique Industries Section - Impact Grid */}
        <section className="relative py-20 sm:py-24 md:py-32 overflow-hidden">
          {/* Animated background glow */}
          <div
            className="absolute top-1/2 left-1/2 w-[800px] h-[800px] bg-blue-600/5 rounded-full blur-[150px] pointer-events-none"
            style={{
              transform: "translate3d(-50%, -50%, 0)",
              left: "50%",
              top: "50%",
              willChange: "transform",
              backfaceVisibility: "hidden",
              WebkitBackfaceVisibility: "hidden",
            }}
          />

          <div className="relative z-10 mx-auto max-w-[1200px] px-6">
            <div className="mb-16 text-center">
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: true }}
                style={{
                  transform: "translate3d(0,0,0)",
                  willChange: "transform, opacity",
                }}
              >
                <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-blue-400/20 bg-blue-500/5 px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.25em] text-blue-400">
                  Industry Impact
                </div>

                <h2 className="text-3xl font-black text-white md:text-5xl lg:text-6xl tracking-tight">
                  Trusted in Every{" "}
                  <span className="text-blue-500">Industry.</span>
                </h2>
              </motion.div>
            </div>

            <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
              {[
                {
                  icon: "🥫",
                  title: "Food & Beverage",
                  impact: "99.9% Moisture Resistance",
                  desc: "Engineered for cold-chain and high-humidity retail environments.",
                },
                {
                  icon: "💊",
                  title: "Pharmaceutical",
                  impact: "GMP-Grade Compliance",
                  desc: "Zero-error printing for critical medical dosages and security seals.",
                },
                {
                  icon: "💄",
                  title: "Cosmetics & Beauty",
                  impact: "Luxury Finishing Focus",
                  desc: "Elevating brand perceived value with premium tactile textures.",
                },
                {
                  icon: "🛒",
                  title: "FMCG & Retail",
                  impact: "High-Volume Speed",
                  desc: "Supporting rapid dispatch cycles with consistent print quality.",
                },
                {
                  icon: "🚚",
                  title: "Logistics",
                  impact: "100% Scan Reliability",
                  desc: "Durable barcode systems for end-to-end supply chain visibility.",
                },
                {
                  icon: "🏪",
                  title: "Specialty Retail",
                  impact: "Boutique Artistry",
                  desc: "Custom die-cuts and holographic security for premium labels.",
                },
              ].map((industry, i) => (
                <motion.div
                  key={industry.title}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.5, delay: i * 0.1 }}
                  style={{
                    transform: "translate3d(0,0,0)",
                    willChange: "transform, opacity",
                  }}
                >
                  {/* STATIC CARD */}
                  <div className="group relative overflow-hidden rounded-[32px] border border-white/5 bg-white/[0.03] p-10 backdrop-blur-xl transition-all duration-300 hover:border-blue-500/30 hover:bg-white/[0.06] hover:-translate-y-1">
                    {/* Glow effect */}
                    <div className="absolute -inset-px bg-gradient-to-br from-blue-500/20 to-transparent opacity-0 transition-opacity duration-500 group-hover:opacity-100" />

                    <div className="relative z-10">
                      <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-2xl bg-white/5 text-4xl shadow-inner transition-transform duration-500 group-hover:scale-110 group-hover:rotate-6">
                        {industry.icon}
                      </div>

                      <h3 className="mb-3 text-2xl font-bold text-white tracking-tight">
                        {industry.title}
                      </h3>

                      <div className="mb-4 inline-block rounded-lg bg-blue-500/10 px-3 py-1 text-[11px] font-black uppercase tracking-wider text-blue-400 transition-colors group-hover:bg-blue-500/20 group-hover:text-blue-300">
                        {industry.impact}
                      </div>

                      <p className="text-sm leading-relaxed text-blue-100/40 transition-colors group-hover:text-blue-100/60">
                        {industry.desc}
                      </p>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </section>

        {/* Trust Quote Section */}
        <section className="relative overflow-hidden py-20 sm:py-24 md:py-32">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[100%] h-[100%] bg-white " />

          <div className="relative z-10 mx-auto max-w-[1000px] px-6 text-center">
            <motion.div
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <div className="mb-3 text-5xl md:text-[60px] text-blue-400 opacity-30 font-serif italic leading-0">
                "
              </div>
              <h2 className="text-[24px] sm:text-3xl font-extrabold italic text-slate-900 md:text-5xl mb-10 leading-tight">
                Consistency is the foundation of trust. We don't just print labels
                we protect your brand standards across every run.
              </h2>
              <div className="h-px w-20 bg-blue-500 mx-auto mb-6" />
              <div className="text-sm font-bold uppercase tracking-[0.3em] text-blue-800">
                The Sahajink Quality Promise
              </div>
            </motion.div>
          </div>
        </section>

        {/* Final CTA */}
        {/* <section className="relative py-24 bg-blue-600">
        <div className="mx-auto max-w-[1200px] px-6 text-center">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl font-black text-white md:text-6xl mb-10">
              Ready to start your next milestone?
            </h2>
            <div className="flex flex-wrap justify-center gap-6">
              <Link
                to="/#contact"
                className="rounded-full bg-white px-12 py-5 text-sm font-bold uppercase tracking-[0.2em] text-blue-600 shadow-xl transition hover:scale-105 hover:bg-blue-50"
              >
                Request Custom Quotation
              </Link>
              <Link
                to="/sample"
                className="rounded-full border-2 border-white/30 bg-white/10 px-12 py-[18px] text-sm font-bold uppercase tracking-[0.2em] text-white backdrop-blur-md transition hover:bg-white/20"
              >
                Order Free Samples
              </Link>
            </div>
          </motion.div>
        </div>
      </section> */}
      </main>
    </>
  );
};

export default OurWorks;
